// Inject original runtime classes
document.body.classList.add('loaded')
document.body.classList.add('mobile')
document.documentElement.classList.add('is_dark')

// Inject Swiper/Vant active states after hydration
setTimeout(() => {
  document.querySelectorAll('.swiper-container').forEach(el => {
    el.classList.add('swiper-container-initialized', 'swiper-container-horizontal')
  })
  document.querySelectorAll('.swiper-wrapper').forEach(el => {
    el.classList.add('swiper-wrapper')
  })
  document.querySelectorAll('.van-tabbar-item:first-child').forEach(el => {
    el.classList.add('van-tabbar-item--active')
  })
}, 100)
